import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Card from 'components/Card';
import security from 'stores/security';
import Steps from '../../components/Steps';

import './style.scss';

/**
 * 邮箱激活
 */
const ActiveEmail: React.FC = () => {
    // 已激活回到安全中心
    if (security.userInfo?.emailActive) {
        return <Navigate to="/profile/security" replace />;
    }

    return (
        <Card form>
            <h2>{__('邮箱验证')}</h2>
            <div className="active-email-root">
                <Steps type="activeEmail" />
                <Outlet />
            </div>
        </Card>
    );
};

export default ActiveEmail;
